import React, { useMemo } from "react";
import {
  BaseTableV2,
  ColumnConfig,
  TableRowVariant,
} from "App/common/BaseTableV2";
import {
  DEFAULT_COLUMNS,
  ENTITY_PREVIEW_METADATA,
  EntityRowConfig,
} from "./config";
import "./EntityTable.scss";

export { DEFAULT_COLUMNS, ENTITY_PREVIEW_METADATA, EntityRowConfig };

export const EntityTable = ({
  rows,
  columns,
  mobileColumns,
  sort,
  onDragEnd,
  onSelect,
  EmptyComponent,
  enableDrag,
  showDragHandle,
  isLoading,
  className,
  isSelectionEnabled,
  tableRowVariant,
  hideSelectionColumn,
}: {
  rows: EntityRowConfig[];
  columns: ColumnConfig[];
  mobileColumns?: ColumnConfig[];
  sort?: (a: EntityRowConfig, b: EntityRowConfig) => number;
  onDragEnd?: (newOrder: EntityRowConfig[]) => void;
  EmptyComponent?: React.FC;
  enableDrag?: boolean;
  showDragHandle?: boolean;
  onSelect?: (row: EntityRowConfig) => void;
  isSelectionEnabled?: boolean;
  isLoading?: boolean;
  className?: string;
  tableRowVariant?: TableRowVariant; // TODO: remove when support added for dialog dropdowns
  hideSelectionColumn?: boolean;
}) => {
  const sortedRows = useMemo(() => {
    return sort ? [...rows].sort(sort) : rows;
  }, [rows, sort]);

  return (
    <BaseTableV2
      EmptyComponent={EmptyComponent}
      columns={columns}
      mobileColumns={mobileColumns}
      onSelect={onSelect}
      isSelectionEnabled={isSelectionEnabled}
      rows={sortedRows}
      className={`entity-table ${className || ""}`}
      onDragEnd={onDragEnd}
      enableDrag={enableDrag}
      showDragHandle={showDragHandle}
      isLoading={isLoading}
      tableRowVariant={tableRowVariant}
      hideSelectionColumn={hideSelectionColumn}
    />
  );
};
